import React from "react";
import Heading from "../../components/Heading";
import Container from "../../components/Container";
import API from "../../services/API";
import PartnerDomainsTable from "./components/PartnerDomainsTable";
import PartnerDomainsFilters from "./components/PartnerDomainsFilters";
import PartnerDomainsForm from "./components/PartnerDomainsForm";

class PartnerDomains extends React.Component{
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            domains: [],
            sortedBy: "",
            editableDomain: {}
        }

        this.handleFieldChange = this.handleFieldChange.bind(this);
        this.onNoteSave = this.onNoteSave.bind(this);
        this.onRemove = this.onRemove.bind(this);
        this.onApply = this.onApply.bind(this);
        this.sort = this.sort.bind(this);
    }

    componentDidMount() {
        this.loadDomains();
    }

    loadDomains() {
        API.PartnerDomains.get().then((domains) => {
            this.setState({ isLoading: false, domains });
        })
    }

    async onApply() {
        this.setState({ isLoading: true });

        const { date_from, date_to } = this.state;

        API.PartnerDomains.get({ date_from, date_to }).then((domains) => {
            this.setState({ isLoading: false, domains });
        })
    }

    handleFieldChange(e) {
        this.setState({ [e.target.name]: e.target.value })
    }

    sort(field) {
        if(this.state.sortedBy === field) {
            return this.setState({ domains: this.state.domains.reverse() })
        }

        this.setState({
            domains: this.state.domains.sort((a, b) => {
                if(field === "flaggedAt") {
                    return new Date(b[field]) - new Date(a[field]);
                }

                if(['virusTotal', 'avastFlagged', 'flagged'].includes(field)) {
                    return parseInt(a[field]) - parseInt(b[field])
                }

                return new Intl.Collator().compare(a[field], b[field])
            }),
            sortedBy: field
        })
    }

    onRemove(id) {
        if(!window.confirm(`Are you sure to delete domain with ID: ${id}?`)) return;

        API.PartnerDomains.remove(id).then(() => {
            this.loadDomains();
        })
    }

    async onNoteSave(id, note) {
        this.setState({ isLoading: true });

        await API.PartnerDomains.update(id, { note });

        this.loadDomains()

        this.setState({ editableDomain: {} });
    }

    render() {
        return (
            <Container loading={this.state.isLoading}>
                <Heading title="Partner Domains"/>

                <PartnerDomainsFilters state={this.state} onApply={this.onApply} handleFieldChange={this.handleFieldChange}/>

                <PartnerDomainsTable sort={this.sort} onNoteEdit={(editableDomain) => this.setState({ editableDomain })} onRemove={this.onRemove} domains={this.state.domains}/>

                { this.state.editableDomain.id && <PartnerDomainsForm onNoteSave={this.onNoteSave} domain={this.state.editableDomain} onHide={() => this.setState({ editableDomain: {} }) }/> }
            </Container>
        )
    }
}

export default PartnerDomains;


// WEBPACK FOOTER //
// ./src/scenes/PartnerDomains/index.js